export const ddTypes = {
  mainCategoryItems: 'main_category_items',
  genderItems: 'gender_items',
  citizenshipItems: 'citizenship_items',
  countriesItems: 'countries_items',
  kupatHolimItems: 'kupat_holim_items',
  familyStatusItems: 'family_status_items',
  bankItems: 'bank_items',
  paymentFrequency: 'payment_frequency_items',
  practiceAreaItems: 'practice_area_items',
  jobTitleItems: 'job_title_items',
  customerTypesItems: 'customer_types_items',
  workRegionTypes: 'work_region_items',
  workCapacityTitles: 'work_capacity_items',
  weekAverageHoursItems: 'week_average_hours_items',
  occupationItems: 'occupation_items',
  spouseIncomeItems: 'spouse_income_items',
  immigrantTypesItems: 'immigrant_types_items',
  cameFromItems: 'came_from_items',
};
